<!-- Responsibility: Implement journal entry behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->
<journal-entry>
  <div
    class="entry { props.entry.isLatest ? 'latest' : 'older' }"
    role="button"
    tabindex="0"
    aria-label={ `Open journal entry at ${props.entry.location}` }
    onclick={ openEntry }
    onkeydown={ onKeydown }
  >
    <header>
      <span class="loc">{ props.entry.location }</span>
      <span class="time">{ props.entry.time }</span>
    </header>
    <raw-html class="prose journal-entry-prose" mode="prose" content={ props.entry.text }></raw-html>
  </div>

  <script>
    import { dispatcher } from '../../app-states.js';
    import { buildInfoDialog } from '../dialog/dialog-openers.ts';
    import { TOPICS } from "@anyquest/shared-core";
    import * as gameStore from '../../game-store.js';
    import RawHtml from '../components/raw-html.riot';

    export default {
      components: { RawHtml },

      onMount() {

      },
      openEntry() {
        const entry = this.props.entry;
        if (!entry) return;
        const gs = gameStore.state;
        const node = gs
          ? Object.values(gs.atlas?.nodes ?? {}).find(n => n?.name === entry.location)
          : null;
        const imageUrl = node?.visionUrl ?? (entry.isLatest ? (gs?.visionUrl ?? null) : null);
        const imageSeed = node?.desc ?? entry.location;

        // History entries are text-first references. No entity/object cards.
        dispatcher.trigger('journal-entry', TOPICS.ui.dialogOpen, buildInfoDialog({
          data: {
            media: {
              imageUrl,
              imageKind: imageUrl ? null : 'vision',
              imageSeed,
              fallbackLabel: entry.location,
            },
          },
          options: {
            title: `${entry.location.toUpperCase()} · ${entry.time}`,
            desc: entry.text,
          },
        }));
      },

      onKeydown(e) {
        if (e.key !== 'Enter' && e.key !== ' ') return
        e.preventDefault()
        this.openEntry()
      },
    };
  </script>

  <style>
    .entry.latest {
      border: 1px solid color-mix(in srgb, var(--gold) var(--alpha-mid), transparent);
      box-shadow: 0 0 0 1px color-mix(in srgb, var(--gold) var(--alpha-low), transparent), 0 0.5rem 1.375rem rgba(0, 0, 0, 0.28);
      animation: journal-latest-pop 0.65s cubic-bezier(0.22, 1, 0.36, 1), journal-latest-glow 1.4s ease-out;
      transform-origin: center top;
    }


  </style>
</journal-entry>
